const sitesData = () => ({
  themes: [
    {
      id: 62047641,
      name: "gatsby",
      color: "red",
      storybook: "http://storybook-gatsby.gigmedia.com/",
      demo: "https://demo-gatsby-theme.gigmedia.com/",
      docs: "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/895484117/Gatsby+Theme",
      release_notes:
        "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2213904675/Core+Theme+-+Version+Release+Notes",
      pipeline_trigger_token: "glptt-d195a41abf5785d515210b91ea7b5179e0cf4de9",
      repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/gatsby-themes",
      sites: [],
      defaultSite: "playcasino.co.za",
    },
    {
      id: 62047619,
      name: "matrix",
      color: "black-10",
      storybook: "http://storybook-matrix.gigmedia.com/",
      demo: "https://demo-matrix-theme.gigmedia.com/",
      docs: "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/895484119/Matrix+Theme",
      pipeline_trigger_token: "glptt-d83ea152250dea8979515d67b7f1bb6d32681c93",
      release_notes: "",
      repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/matrix-theme",
      sites: [
        {
          id: 62047239,
          name: "meutimao.com.br",
          logo: "https://www.meutimao.com.br/apostas/images/logo.svg",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/meutimao",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 77582177,
          name: "odia.ig.com.br",
          logo: "https://dev.oapostas.com/images/logo.svg",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/oapostas.com",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046692,
          name: "irishluck.ie",
          logo: "https://www.irishluck.ie/images/logo.svg",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/irishluck-matrix",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046687,
          name: "norskespilleautomater.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/nsa-matrix",
          logo: "https://assets-srv.s3.eu-west-1.amazonaws.com/nsa-logo-2-1-1.png",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046655,
          name: "playcasino.co.za",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/pcsa-matrix",
          logo: "https://www.playcasino.co.za/images/logo.png",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046633,
          name: "onlinegamblingsa.co.za",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/ogsa-matrix",
          logo: "https://assets-srv.s3.eu-west-1.amazonaws.com/1653996619/logo-%281%29.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046554,
          name: "onlinecasinosouthafrica.net",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/ocsa-matrix",
          logo: "https://www.onlinecasinosouthafrica.net/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046533,
          name: "free-casinos.co.za",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/FC-Matrix",
          logo: "https://www.free-casinos.co.za/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046437,
          name: "onlinegamblingsa.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/ogsa.com-matrix",
          logo: "https://www.onlinegamblingsa.com/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046434,
          name: "habibibet.org",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/habibibet.org-matrix",
          logo: "https://www.habibibet.org/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046411,
          name: "nät-casino.se",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/nat-casino",
          logo: "https://assets-srv.s3.eu-west-1.amazonaws.com/1692277900/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046328,
          name: "casinomobile.co.za",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/cm-matrix",
          logo: "https://assets-srv.s3.eu-west-1.amazonaws.com/1692277900/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046297,
          name: "betamericalatina.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/bal-matrix",
          logo: "https://www.betamericalatina.com/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 62046271,
          name: "onlinecasinosonline.co.za",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/oco-matrix",
          logo: "https://www.onlinecasinosonline.co.za/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/GMPP/pages/2450817238/2022+Matrix+sites",
        },
        {
          id: 71709929,
          name: "superbonusschweiz.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/superbonusschweiz.com",
          logo: "",
          release_notes: "",
        },
        {
          id: 67678653,
          name: "AFGA-Matrix",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/afga-matrix",
          logo: "",
          release_notes: "",
        },
        {
          id: 67342921,
          name: "RBC-Matrix",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/rbc-matrix",
          logo: "",
          release_notes: "",
        },
        {
          id: 64713826,
          name: "Casinon.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/casinon.com",
          logo: "",
          release_notes: "",
        },
        {
          id: 71086777,
          name: "betting.livegoals.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/matrix-sites/betting.livegoals.com",
          logo: "",
          release_notes: "",
        },
      ],
      defaultSite: "irishluck.ie",
    },
    {
      id: 62047551,
      name: "rocket",
      color: "red",
      storybook: "",
      demo: "https://demo-rocket-theme.gigmedia.com/",
      docs: "",
      release_notes: "",
      pipeline_trigger_token: "glptt-7689beb8da0ef8f4559075a2265a39a44a672f4b",
      repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/rocket-theme",
      sites: [
        {
          id: 62047456,
          name: "casinossuisses.org",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/rocket-sites/casinossuisses",
          logo: "https://casinossuisses.org/images/logo.svg",
          release_notes: "",
        },
        {
          id: 64651479,
          name: "casinosvizzera.org",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/rocket-sites/casinosvizzera.org",
          logo: "https://casinosvizzera.org/images/logo.svg",
          release_notes: "",
        },
      ],
    },
    {
      id: 62047581,
      name: "sports",
      color: "blue",
      storybook: "http://storybook-rage-seo.gigmedia.com/",
      demo: "https://demo-sports-theme.gigmedia.com/",
      docs: "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2767224851/Hercules+Site+Configuration",
      release_notes:
        "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2211053859/SEO+Version+Release+Notes",
      pipeline_trigger_token: "glptt-aedd678f09881431ae3b43e8597e56087f272961",
      repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/sports-theme",
      sites: [
        {
          id: 62047515,
          name: "betbroz.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/sports-sites/betbroz.com",
          logo: "https://assets-srv.s3.eu-west-1.amazonaws.com/1688477063/betbroz.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2767224851/Hercules+Site+Configuration",
        },
        {
          id: 66616630,
          name: "livegoals.com",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/sports-sites/livegoals",
          logo: "https://www.livegoals.com/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2767224851/Hercules+Site+Configuration",
          excludeBranches: ['develop', 'qa-automation', 'master'],
          includeBranches: [
            {
              name: "Develop",
              branch: "develop",
              siteUrlTag: "dev2",
              after: 'prelive',
            },
          ],
        },
        {
          id: 62047484,
          name: "sportwetten-bonus.de",
          repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/sports-sites/SWB.DE",
          logo: "https://sportwetten-bonus.de/images/logo.svg",
          release_notes:
            "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2767224851/Hercules+Site+Configuration",
          excludeBranches: ['qa-automation'],
        },
      ],
    },
    {
      id: 62047581,
      name: "crypto",
      color: "purple",
      storybook: "http://storybook-rage-seo.gigmedia.com/",
      demo: "https://demo-crypto-theme.gigmedia.com/",
      docs: "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2767224851/Hercules+Site+Configuration",
      release_notes:
        "https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2211053859/SEO+Version+Release+Notes",
      pipeline_trigger_token: "glptt-aedd678f09881431ae3b43e8597e56087f272961",
      repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/crypto-theme",
      sites: [
        // {
        //   id: 69248130,
        //   name: "Bitedge",
        //   repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/crypto-sites/bitedge",
        //   logo: "",
        //   release_notes: "",
        // },
        // {
        //   id: 66868437,
        //   name: "coin-ratgeber.de",
        //   repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/crypto-sites/coin-ratgeber.de",
        //   logo: "",
        //   release_notes: "",
        // },
      ],
    },
    // {
    //   id: 62047583,
    //   name: "partnerships",
    //   color: "orange",
    //   storybook: "",
    //   demo: "",
    //   docs: "",
    //   release_notes: "",
    //   pipeline_trigger_token: "glptt-5b027477e89bd55ee1b78bb45ff229bbd0cee752",
    //   repo: "https://gitlab.com/g2m-gentoo/team-floyd/themes/partnerships-theme",
    //   sites: [
    //     {
    //       id: 67124688,
    //       name: "gmbl",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/gmbl",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047293,
    //       name: "thesun",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047291,
    //       name: "talksport",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047263,
    //       name: "Pressreleases",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/pressreleases",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047261,
    //       name: "thesun-ie",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-ie",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047256,
    //       name: "thesun-us",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-us",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047254,
    //       name: "talksport-ie",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-ie",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047251,
    //       name: "talksport-us",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-us",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047246,
    //       name: "deportesyapuestas",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/deportesyapuestas",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047243,
    //       name: "pulzo",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/pulzo",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047240,
    //       name: "crickettimes",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/crickettimes",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047239,
    //       name: "meutimao",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/meutimao",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047235,
    //       name: "mysafegame",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/mysafegame",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047234,
    //       name: "thesun-aus",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-aus",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047232,
    //       name: "opovo",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/opovo",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047227,
    //       name: "talksport-za",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-za",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047222,
    //       name: "thesun-ng",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-ng",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047221,
    //       name: "thesun-za",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-za",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047219,
    //       name: "talksport-aus",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-aus",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047217,
    //       name: "talksport-ng",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-ng",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047195,
    //       name: "Calciomercato",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/calciomercato",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047193,
    //       name: "askgamblers",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/askgamblers",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047191,
    //       name: "thesun-ca",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-ca",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047190,
    //       name: "thesun-on",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/thesun-on",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047185,
    //       name: "talksport-ca",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-ca",
    //       logo: "",
    //       release_notes: "",
    //     },
    //     {
    //       id: 62047182,
    //       name: "talksport-on",
    //       repo: "https://gitlab.com/g2m-gentoo/team-floyd/gatsby-sites/partnerships/talksport-on",
    //       logo: "",
    //       release_notes: "",
    //     },
    //   ],
    // },
  ],
});

export default sitesData;
